import { defineStore } from 'pinia'

export const useApi = defineStore('api', {
    state: () => ({
        snack: {
            snackVisible: false,
            snackText: null,
            snackColor: null,
        },
    }),

    getters: {
        sVisible() {
            return this.snack;
        },
    },

    actions: {
        async doRequest(endpoint, method, data, formdataMode) {
            let fetchOptions = {
                method: method,
                headers: {},
            };
            if (data != null) {
                if (formdataMode) {
                    fetchOptions.body = data;
                } else {
                    fetchOptions.headers['content-type'] = 'application/json';
                    fetchOptions.body = JSON.stringify(data);
                }
            }
            
            try {
                var r = await fetch(`/api${endpoint}`, fetchOptions);
            } catch (e) {
                console.error(e);
                throw e;
            }

            if (r.status != 200) {
                const rJson = await r.json();
                this.showSnack(rJson.detail?.length ? rJson.detail[0].msg : rJson.detail, 'red');
                console.error(rJson);
                return rJson;
            } else {
                const rJson = await r.json();
                if (rJson.success) {
                    return rJson                    
                } else {
                    this.showSnack(rJson.msg, 'red');
                }
            }
        },

        getFromCookieAndDecodeToken() {
            let parseCookie = document.cookie.split('; ');
            const accessTokenRegex = /^(access_token)=([^;]*)/;
            let token;
            for (const cookie of parseCookie) {
                const match = cookie.match(accessTokenRegex);
                if (match) {
                    token = match[2];
                }
            }
            return token ? token : undefined;
        },

        showSnack(text, color) {
            this.snack.snackText = text;
            this.snack.snackColor = color;
            this.snack.snackVisible = true;
        },

        closeSnack() {
            this.snack.snackVisible = false;
        },

        async auth(obj) {
            await this.doRequest('/login', 'POST', obj)
        },

        async sync(formdata) {
            return await this.doRequest('/update_data_stream', 'POST', formdata, true)
        },

        async get_log_today() {
            try {
                const r = await fetch(`/api/get_log_today`, { method: 'GET' });
                if (!r.ok) {
                    const errText = await r.text();
                    this.showSnack(errText, 'red');
                    return null;
                }
                return r; 
            } catch (e) {
                this.showSnack('Ошибка при получении лога', 'red');
                console.error(e);
                return null;
            }
        }
    }
})